import RejectRewardsForm from './RejectRewardsForm';

export default RejectRewardsForm;
